import { jSocialEventView, jSocialEventViewSchema } from '../types/socialEvent';

export const ensureIsViewEvent = (o: unknown): o is jSocialEventView => {
    return jSocialEventViewSchema.safeParse(o).success;
};
